<!-- Using new control flow syntax (Angular 17+) -->
@if (isLoading()) {
  <div class="loading-container">
    <p>Cargando...</p>
    <div class="spinner"></div>
  </div>
} @else if (error()) {
  <div class="error-container">
    <p class="error-message">{{ error() }}</p>
    <button (click)="retry()" class="retry-button">Reintentar</button>
  </div>
} @else if (showContent() && hasValidGsid()) {
  <app-login [gsid]="gsid()"></app-login>
} @else {
  <div class="initializing-container">
    <p>Inicializando aplicación...</p>
  </div>
}
